/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PatternValueExtractor { 
    id?: number;
    valueType?: PatternValueExtractor.ValueTypeEnum;
    linePattern?: string;
    valuePattern?: string;
    ignorePattern?: string;
    lineSeq?: number;
    valueSeq?: number;
}
export namespace PatternValueExtractor {
    export type ValueTypeEnum = 'COMPANY_NO' | 'INVOICE_DATE' | 'INVOICE_TIME' | 'INVOICE_NO' | 'PRICE' | 'JIR';
    export const ValueTypeEnum = {
        CompanyNo: 'COMPANY_NO' as ValueTypeEnum,
        InvoiceDate: 'INVOICE_DATE' as ValueTypeEnum,
        InvoiceTime: 'INVOICE_TIME' as ValueTypeEnum,
        InvoiceNo: 'INVOICE_NO' as ValueTypeEnum,
        Price: 'PRICE' as ValueTypeEnum,
        Jir: 'JIR' as ValueTypeEnum
    };
}


